module.exports = (__webpack_require__(30459))(70);